import NumberFormats from "components/NumberFormats";
import { Typography } from "@mui/material";

export function Price({ data }) {
  return (
    <>
      <Typography
        fontWeight="600"
        color="success.main"
        component="p"
        sx={{ cursor: "pointer" }}
      >
        <NumberFormats displayType={"text"} value={parseFloat(data.priceBuy)} />
      </Typography>

      <Typography
        variant="h6"
        fontWeight="600"
        color="error.main"
        component="p"
        sx={{ cursor: "pointer" }}
      >
        <NumberFormats
          displayType={"text"}
          value={parseFloat(data.priceSell)}
        />
      </Typography>
    </>
  );
}

export default Price;
